import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Button from '@components/common/Button';
import CommonFormFields from '@pages/Forms/CommonFormFields';
import './approvalModal.css'
import { buttonNames } from '@constants/appConstants';
import { setComments } from '@store/actions/approvalActions';
import { useDispatch } from 'react-redux';

interface ApprovalModalProps {
    showModal: boolean;
    handleModalClose: () => any;
    handleSubmit: () => any;
    headerText: string,
    isCommentsRequired: boolean
}

interface objectTypes {
    isError: boolean,
    message: string,
    isDisable: boolean,
    value: any,
    id?: any,
    verifiedDetails?: any
    code?: number
}
interface formStateType {
    [key: string]: objectTypes
}

interface formDataType {
    [key: string]: any;
}

const ApprovalModal: React.FC<ApprovalModalProps> = ({
    showModal, handleModalClose, handleSubmit, headerText, isCommentsRequired
}) => {

    const [modalForm, setModalForm] = useState<formStateType>({
        comments: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        }
    });
    const dispatch = useDispatch();

    const [modalFormData, setModalFormData] = useState<formDataType>({
        comments: {
            '#type': 'textArea',
            '#title': 'Add Comments',
            '#webform_key': 'comments',
            '#required': isCommentsRequired,
            '#isDisabled': false,
        }
    })

    const handleFormChange = (value: any, key: string, id?: any, option?: any, code?: any) => {
        setModalForm((prevState: any) => ({
            ...prevState,
            [key]: {
                ...prevState[key],
                value: value,
                isError: false,
                message: '',
                id: id,
                code: code
            },
        }));
        dispatch(setComments(value));
    }

    const handleSubmitStatusChange = () => {
        handleSubmit();
    }

    return (
        <div className="approval-modal">
            <Modal
                show={showModal}
                onHide={() => { }}
                dialogClassName={'approval-modal'}
                centered={true}
                backdrop="static"
            >
                <Modal.Header>
                    <div className="approval-modal-header">
                        <div
                            className="d-flex align-items-center beneficiary_back_button"
                            onClick={handleModalClose}
                        >
                            <i className="bi bi-arrow-left" style={{ cursor: "pointer" }} ></i>
                            <span className="ms-1">Back</span>
                        </div>
                        <div
                            className="d-flex align-items-center beneficiary_discard_button"
                            onClick={handleModalClose}
                        >
                            <span className="me-0">Discard</span>
                            <i className="bi bi-x" ></i>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body  >
                    <div className='approval-modal'>
                        {
                            <div className='approval-modal-container'>
                                <span className='approval-modal-header-text'>{headerText}</span>
                                <form className="container_health_block">
                                    <CommonFormFields
                                        formData={modalFormData}
                                        formState={modalForm}
                                        handleFormChange={handleFormChange}
                                    />
                                </form>
                                <div className="approval-submit">
                                    <Button
                                        onClick={() => { handleSubmitStatusChange() }}
                                        disabled={isCommentsRequired && !modalForm?.comments?.value}
                                        id="approval-submit-button"
                                        buttonName={buttonNames.submit}
                                        colorType={'primary'}
                                        icon={''}
                                        iconPosition={''} /></div>
                            </div>}
                    </div>
                </Modal.Body>
            </Modal>
        </div>);
};

export default ApprovalModal;